import Offcanvas from "react-bootstrap/Offcanvas";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";

interface Props {
  show: boolean;
  onHide: () => void;
}

const ExportEventsOffcanvas = ({ show, onHide }: Props) => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const validateDates = () => {
    setError("");

    if (!fromDate || !toDate) {
      setError("Please select both From Date and To Date");
      return false;
    }

    const from = new Date(fromDate);
    const to = new Date(toDate);

    if (to < from) {
      setError("To Date must be greater than From Date");
      return false;
    }

    const diffTime = to.getTime() - from.getTime();
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    if (diffDays > 365) {
      setError("Date range cannot be greater than 1 year");
      return false;
    }

    return true;
  };

  const handleExport = async () => {
    if (!validateDates()) return;
    setLoading(true);

    try {
      const params = new URLSearchParams();
      if (fromDate) params.append("fromDate", fromDate);
      if (toDate) params.append("toDate", toDate);

      const res: any = await WebService.getBlobAPI({
        action: `event-registration/export-bookings?${params.toString()}`,
        responseType: "blob", // 🔥 IMPORTANT
      });

      const blob = new Blob([res.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "Export Event Bookings.csv";
      a.click();

      window.URL.revokeObjectURL(url);
      onHide();
    } catch (err: any) {
      console.error("Export failed", err);
      // ✅ If backend sends JSON message in blob format
      if (err?.response?.data instanceof Blob) {
        const text = await err.response.data.text();

        try {
          const json = JSON.parse(text);
          toast.error(json.message || "No data found");
        } catch {
          toast.error("No bookings found for selected date range");
        }
      } else {
        toast.error(err?.response?.data?.message || "Export failed");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Offcanvas show={show} onHide={onHide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Export Event Bookings</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <div className="mb-3">
          <label>Booking From Date</label>
          <input
            type="date"
            className="form-control"
            value={fromDate}
            onChange={(e) => {
              setFromDate(e.target.value);
              setError("");
            }}
          />
        </div>

        <div className="mb-3">
          <label>Booking To Date</label>
          <input
            type="date"
            className="form-control"
            value={toDate}
            onChange={(e) => {
              setToDate(e.target.value);
              setError("");
            }}
          />
        </div>

        {/* 🔥 Validation Error */}
        {error && <p className="text-danger mb-2">{error}</p>}

        <CustomButton
          label="Export"
          isLoading={loading}
          onClick={handleExport}
        />
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ExportEventsOffcanvas;
